import React from 'react';
import { observer, inject } from 'mobx-react';
import { Table, Button, Input } from 'antd';
import { AddGroupTable } from '../../const/TableConst';
import styles from './DeviceSearchForm.less';

@inject('addGroupStore')
@observer
class DeviceSearchTable extends React.Component {
  onSelectChange = (selectedRowKeys, selectedRows) => {
    this.props.addGroupStore.selectedDeviceArr = [...selectedRows];
    this.props.addGroupStore.selectedRowKeys = [...selectedRowKeys];
  };
  addSelectRow = record => {
    this.props.addGroupStore.selectedDeviceArr.push(record);
    this.props.addGroupStore.selectedRowKeys.push(record.key);
  };
  handelRowSelect = (record, index, event) => {
    if (!![...this.props.addGroupStore.selectedDeviceArr].length) {
      let selectItem = [
        ...this.props.addGroupStore.selectedDeviceArr
      ].findIndex(a => a.key === record.key);
      if (selectItem > -1) {
        this.props.addGroupStore.selectedDeviceArr.splice(selectItem, 1);
        this.props.addGroupStore.selectedRowKeys.remove(record.key);
      } else {
        this.addSelectRow(record);
      }
    } else {
      this.addSelectRow(record);
    }
  };
  render() {
    const {
      searchDeviceArr,
      selectedDeviceArr,
      searchDevicePageSize,
      changeSearchDevicePageSize,
      selectedRowKeys
    } = this.props.addGroupStore;
    const rowSelection = {
      selectedRowKeys: [...selectedRowKeys],
      onChange: this.onSelectChange
    };
    const hasSelected = selectedDeviceArr.length > 0;
    return (
      <div>
        <div style={{ marginBottom: 16 }}>
          <span style={{ marginLeft: 8 }}>
            {hasSelected ? `选择了${selectedDeviceArr.length} 台设备` : ''}
          </span>
        </div>
        <Table
          pagination={{
            showTotal: total => (
              <div className={styles.pageSizeContainer}>
                <span>每页显示条数</span>
                <Input
                  className={styles.numInput}
                  defaultValue={10}
                  type="text"
                  onChange={e => changeSearchDevicePageSize(e)}
                />
              </div>
            ),
            pageSize: searchDevicePageSize
          }}
          rowSelection={rowSelection}
          columns={AddGroupTable}
          dataSource={[...searchDeviceArr]}
          onRowClick={this.handelRowSelect}
        />
      </div>
    );
  }
}
export default DeviceSearchTable;



// WEBPACK FOOTER //
// ./src/components/DeviceGroup/DeviceSearchTable.js